const RemoteApplicationStatusEnum = Object.freeze({
    DRAFT: 'DRAFT',
    SENT: 'SENT',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED'
});

export default RemoteApplicationStatusEnum;
